export interface EmailConfiguration {
    materialRequestEmail: string;
    suggestionEmail: string;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface EmailConfigurationFormData {
    materialRequestEmail: string;
    suggestionEmail: string;
}

export interface SystemConfiguration {
    emailConfig: EmailConfiguration;
    maxFileSize: number;
    allowedFileTypes: string[];
    maxBanners: number;
}